var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import EventView from "../presentation/events";
import axios from 'axios';
import moment from "moment";
import CONSTS from "../consts";
export default class Events extends React.Component {
    constructor(props) {
        super(props);
        this.updateTime = (time) => {
            this.setState({ timeFilter: time, selectedEvent: null }, () => this.getEvents());
        };
        this.updateSelectedEvent = (event) => {
            this.setState({ selectedEvent: event });
        };
        this.updateMap = () => {
            this.setState({ toggleMap: !this.state.toggleMap });
        };
        this.state = {
            timeFilter: "ALL EVENTS",
            events: [],
            selectedEvent: null,
            toggleMap: false
        };
    }
    componentDidMount() {
        this.getEvents();
    }
    getEvents() {
        return __awaiter(this, void 0, void 0, function* () {
            let oDataPath = CONSTS.APIURL;
            let date = new Date(), y = date.getFullYear(), m = date.getMonth();
            let firstDay = new Date(y, m, 1);
            let lastDay = new Date(y, m + 1, 0);
            let thisMonthFilter = `((EndDate ge ${moment(firstDay).toISOString()} and EndDate le ${moment(lastDay).toISOString()}) or (StartDate ge ${moment(firstDay).toISOString()} and StartDate le ${moment(lastDay).toISOString()}))`;
            let query = this.state.timeFilter === "ALL EVENTS" ?
                `${oDataPath}Events?$orderby=StartDate&$filter=EndDate ge ${moment().toISOString()}&$expand=RelatedProducts,Licensee` :
                `${oDataPath}Events?$orderby=StartDate&$filter=EndDate ge ${moment().toISOString()} and ${thisMonthFilter}&$expand=RelatedProducts,Licensee`;
            let EventsPromise = yield axios.get(query);
            this.setState({
                events: EventsPromise.data.value
            });
        });
    }
    render() {
        return (React.createElement(EventView, Object.assign({}, this.state, { updateTime: this.updateTime, updateSelectedEvent: this.updateSelectedEvent, updateMap: this.updateMap })));
    }
}
;
//# sourceMappingURL=events.js.map